import { render, staticRenderFns } from "./PersonaCbuForm.vue?vue&type=template&id=3c77a20d&scoped=true"
import script from "./PersonaCbuForm.vue?vue&type=script&lang=js"
export * from "./PersonaCbuForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c77a20d",
  null
  
)

export default component.exports